<template>
    <card xs-tile sm-tile class="stretch-layout">
        <div class="py-16 px-16 lg:px-24 border-b">
            <wrapper left grow>
                <btn :to="$web('events.results.index', eventStore.event._key)" exact>
                    <icon :icon="icons.back" />
                    <span>{{ $t('action.show_all_result_list_groups') }}</span>
                </btn>
            </wrapper>
        </div>
        <card-title><h2 class="text-md mb-0">{{ resultListGroup.name }}</h2></card-title>
        <card-subtitle v-if="participationClassName && !resultListGroup.description">{{ participationClassName }}</card-subtitle>
        <card-subtitle v-else-if="resultListGroup.description">{{ resultListGroup.description }}</card-subtitle>

		<ranks-table v-model:list="selectedResultListKey" :list-group="resultListGroup" :event="eventStore.event" as-guest :cache-buster="cacheBusterValue" class="lg:px-8 stretch-layout">
			<template v-if="resultListGroup.is_downloadable && $breakpoint.smAndUp" #buttons>
				<form-btn :action="$api('events.result_list_groups.download', [eventStore.event.id, resultListGroup._key])" method="GET" @success="url => handleDownloadRequest('participation_results', url, resultListGroup._key, resultListGroup.name)" :data="downloadData">
					<icon :icon="icons.download"/>
					<span>{{ $t('action.download') }}</span>
				</form-btn>
			</template>
		</ranks-table>
    </card>
</template>

<script setup lang="ts">
import {EventPageType} from "@spoferan/spoferan-ts-core";
import {backIcon, downloadIcon} from "@spoferan/nuxt-spoferan/icons";
import {useEventStore} from "../../../../store/event";

const eventStore = useEventStore();
const {t} = useI18n();
const {$web, $api, $analytics, $downloadFile} = useNuxtApp();
const route = useRoute();

// Make sure the page is activated
const page = eventStore.getPage(EventPageType.Results);
if (!page) {
	await navigateTo(eventStore.hasActivePage(EventPageType.Participations) ? $web('events.participations.index', eventStore.event._key) : $web('events.show', eventStore.event._key));
}

const {value: cacheBusterValue} = useCacheBuster('group_ts');

const {data: resultListGroup} = await useApiFetch($api('events.result_list_groups.show', [eventStore.event.id, route.params.group]), {
	guest: true,
	params: {
		ts: cacheBusterValue,
		relations: ['columns', 'lists', 'participationClasses.settings']
	} // Settings required to display pace
});

if (resultListGroup && resultListGroup._key !== route.params.group) {
	await navigateTo({params: {group: resultListGroup._key}}, {
		redirectCode: 308
	});
}

const selectedResultListKey = ref(route.query.list);

const participationClassName = resultListGroup.participationClasses.map(participationClass => participationClass.name).join(', ');

const downloadData = computed(() => {
	return {format: 'pdf', anonymize: true, lists: selectedResultListKey.value ? [selectedResultListKey.value] : []}
});

const icons = {
	back: backIcon,
	download: downloadIcon
};

function handleDownloadRequest(type, url, name = undefined, key = undefined) {
	$analytics.track({
		event: 'download',
		model_type_name: type,
		model_name: name,
		model_key: key,
		url: url
	});

	$downloadFile(url);
}

useMeta({
	title: eventStore.buildPageTitle(t('view.events.results.show.title', {event: eventStore.event.display_name, group: resultListGroup.name})),
	description: t('view.events.results.show.description', {event: eventStore.event.display_name, group: resultListGroup.name}),
});
</script>

